export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_EU-en-GB.e9286173.xlsx";